import React from 'react';
import { Card, Button, ButtonGroup } from 'react-bootstrap';
import { PencilSquare, TrashFill, ThreeDots } from 'react-bootstrap-icons';

const CategoriaCard = ({ categoria, index, handleEditClick, handleDeleteClick, onDragStart, onDrop, onDragOver }) => (
  <div
    className="col-12 col-sm-6 col-md-4 col-lg-3 p-2"
    draggable
    onDragStart={(e) => onDragStart(e, index)}
    onDragOver={onDragOver}
    onDrop={(e) => onDrop(e, index)}
  >
    <Card className="h-100">
      <div style={{ position: 'relative' }}>
        <Card.Img
          variant="top"
          src={categoria.imgCategoria}
          alt={categoria.nomCategoria}
          height={300}
          className=' object-fit-cover'
        />
        <div style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          cursor: 'pointer',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          borderRadius: '50%',
          padding: '5px'
        }}>
          <ThreeDots size={18} className='text-dark' />
        </div>
      </div>
      <Card.Body className="text-center">
        <div>
          <Card.Title className='m-2'>{categoria.nomCategoria}</Card.Title>
          <small className='text-muted'>Productos: {categoria.totalProductos}</small>
        </div>
        <ButtonGroup aria-label="Basic example" className='m-2 mt-3'>
          <Button variant="warning" className="btn-sm" onClick={handleEditClick}
            disabled={categoria.nomCategoria.toLowerCase() === 'otros'}
          >
            <PencilSquare />
          </Button>
          <Button variant="danger" className="btn-sm" onClick={handleDeleteClick}
            disabled={categoria.nomCategoria.toLowerCase() === 'otros'}
          >
            <TrashFill />
          </Button>
        </ButtonGroup>
      </Card.Body>
    </Card>
  </div>
);

export default CategoriaCard;
